module.exports = __webpack_public_path__ + "img/teacher-sample-2.23ef4414.png";